import { render, staticRenderFns } from "./productcolordetails.vue?vue&type=template&id=1b814137&scoped=true&"
import script from "./productcolordetails.vue?vue&type=script&lang=js&"
export * from "./productcolordetails.vue?vue&type=script&lang=js&"
import style0 from "./productcolordetails.vue?vue&type=style&index=0&id=1b814137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b814137",
  null
  
)

export default component.exports